import { render, staticRenderFns } from "./statisticCard.vue?vue&type=template&id=57e9a861"
import script from "./statisticCard.vue?vue&type=script&lang=js"
export * from "./statisticCard.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports